import { c as _c } from "react/compiler-runtime";
import { CurrencyLockup, CurrencyLockupAvatar } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { usePersona } from "@opensea/navigation";
import { Item, ItemContent, ItemDescription, ItemSide, ItemTitle } from "@opensea/next-ui-kit";
import { classNames, SkeletonCircle, StatChange, TextBody, TextBodySkeleton, Truncate, tableRowSizeVariants, tv } from "@opensea/ui-kit";
import { CurrencyPrice } from "@/components/currencies/CurrencyPrice";
import { ExpandedSearch_currencyFragment } from "../ExpandedSearch.fragment";
import { useExpandedSearchResultSize } from "./hooks";
const {
  container
} = tv({
  slots: {
    container: "h-16 border-none p-0"
  }
})();
const randomCurrencyNameWidths = ["w-1/2", "w-1/3", "w-2/5", "w-3/5"];
export const mapCurrencyToSearchResultItem = currencyKey => {
  const currency = readFragment(ExpandedSearch_currencyFragment, currencyKey);
  return {
    id: currency.id,
    data: currencyKey,
    type: "currency"
  };
};
export function ExpandedSearchCurrencyResult(t0) {
  const $ = _c(29);
  const {
    item,
    onSelect,
    className,
    hideStats
  } = t0;
  let t1;
  if ($[0] !== item.data) {
    t1 = readFragment(ExpandedSearch_currencyFragment, item.data);
    $[0] = item.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currency = t1;
  const {
    persona
  } = usePersona();
  const size = persona === "collector" ? "lg" : "md";
  let t2;
  if ($[2] !== className) {
    t2 = classNames(container(), "hover:bg-transparent", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CurrencyLockupAvatar />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currency || $[6] !== size) {
    t4 = <CurrencyLockup className="shrink-0 w-auto" currency={currency} size={size}>{t3}</CurrencyLockup>;
    $[5] = currency;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currency.name) {
    t5 = <ItemTitle><Truncate>{currency.name}</Truncate></ItemTitle>;
    $[8] = currency.name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== currency.symbol) {
    t6 = <ItemDescription><TextBody>{currency.symbol}</TextBody></ItemDescription>;
    $[10] = currency.symbol;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <ItemContent>{t5}{t6}</ItemContent>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== currency) {
    t8 = <TextBody><CurrencyPrice currency={currency} /></TextBody>;
    $[15] = currency;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== currency.stats || $[18] !== hideStats) {
    t9 = !hideStats && currency.stats?.oneDay.priceChange !== undefined && <TextBody className="shrink-0 font-mono text-sm"><StatChange change={currency.stats.oneDay.priceChange} /></TextBody>;
    $[17] = currency.stats;
    $[18] = hideStats;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <ItemSide className="items-end text-right text-sm">{t8}{t9}</ItemSide>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onSelect || $[24] !== t10 || $[25] !== t2 || $[26] !== t4 || $[27] !== t7) {
    t11 = <Item className={t2} onClick={onSelect}>{t4}{t7}{t10}</Item>;
    $[23] = onSelect;
    $[24] = t10;
    $[25] = t2;
    $[26] = t4;
    $[27] = t7;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
export function ExpandedSearchCurrencyResultSkeleton(t0) {
  const $ = _c(23);
  const {
    index,
    hideStats,
    className
  } = t0;
  const size = useExpandedSearchResultSize();
  let t1;
  if ($[0] !== className) {
    t1 = classNames(container(), "px-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== size) {
    t2 = classNames(tableRowSizeVariants({
      size
    }).image(), "shrink-0");
    $[2] = size;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="shrink-0 w-auto"><SkeletonCircle className={t2} /></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = randomCurrencyNameWidths[index % randomCurrencyNameWidths.length];
  let t5;
  if ($[6] !== t4) {
    t5 = <ItemTitle className="w-1/2"><TextBodySkeleton className={t4} /></ItemTitle>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = randomCurrencyNameWidths[(index + 1) % randomCurrencyNameWidths.length];
  let t7;
  if ($[8] !== t6) {
    t7 = <ItemDescription className="w-1/4"><TextBodySkeleton className={t6} /></ItemDescription>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <ItemContent>{t5}{t7}</ItemContent>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TextBodySkeleton />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== hideStats) {
    t10 = !hideStats && <TextBodySkeleton className="w-1/2 shrink-0" size="xs" />;
    $[14] = hideStats;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <ItemSide className="w-[100px] items-end text-right text-sm">{t9}{t10}</ItemSide>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t1 || $[19] !== t11 || $[20] !== t3 || $[21] !== t8) {
    t12 = <Item className={t1}>{t3}{t8}{t11}</Item>;
    $[18] = t1;
    $[19] = t11;
    $[20] = t3;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}